import { Button, ButtonProps } from '@mui/material'
import { Device } from '../types'
import { useTranslation } from 'react-i18next'
import { usePolicy, useDialog } from '../hooks'
import DeviceDetachDialog from './DeviceDetachDialog'
import { LinkOff } from '@mui/icons-material'

export interface DeviceDetachButtonProps extends Omit<ButtonProps, 'onClick' | 'children'> {
  /**
   * The device
   */
  device: Device

  /**
   * The button label.
   */
  label?: string
}

export default function DeviceDetachButton({ device, label, ...props }: DeviceDetachButtonProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('common')

  /**
   * The dialog.
   */
  const { open, openDialog, closeDialog } = useDialog()

  /**
   * The policy state.
   */
  const { canEditDevice } = usePolicy()

  return (
    <>
      {canEditDevice(device) && (
        <Button
          variant="text"
          color="warning"
          startIcon={<LinkOff />}
          {...props}
          onClick={openDialog}
        >
          {label ?? t('detachFromProject')}
        </Button>
      )}

      <DeviceDetachDialog
        device={device}
        open={open}
        onClose={closeDialog}
        afterSubmit={closeDialog}
      />
    </>
  )
}
